import type { Poem } from './types.js'
import {normalizeLine,poemVerses,type RoomKind} from '../../shared/readingCore.js'
export {defaultPreferences,normalizeLine,poemVerses} from '../../shared/readingCore.js'
export type {ReaderPreferences,RoomKind} from '../../shared/readingCore.js'
export interface ReadingRoom {
  entryCount: number
  id: string; kind: RoomKind; title: string; keyword: string; poemIds: string[]; ownerId: string; status: 'invited' | 'active'; createdAt: string
  members: { userId: string; nickname: string; status: string; readIds: string[] }[]
  entries: { id: string; userId: string; nickname: string; body: string; poemId: string; createdAt: string }[]
  turnUserId: string
}
export interface ReadingHistory { date: string; poemId: string }
export interface ReaderDestination {kind: RoomKind | 'today';id?:string}
export function readerDestination(value: unknown): ReaderDestination | null {
  if(typeof value!=='string')return null
  try {const u=new URL(value,'https://shixu.yourchatxuan.top');if(u.origin!=='https://shixu.yourchatxuan.top'||u.pathname!=='/')return null
    if(u.searchParams.get('readingReminder')==='1')return {kind:'today'}
    const kind=u.searchParams.get('readerKind'),id=u.searchParams.get('readerRoom')
    return kind&&['flying','relay','reading'].includes(kind)&&id&&/^[0-9a-f-]{36}$/i.test(id)?{kind:kind as RoomKind,id}:null
  }catch{return null}
}
export const featureKey = (userId: string, name: string) => `shixu.features.v1.${userId}.${name}`
export function readLocal<T>(userId: string, name: string, fallback: T): T {
  try { const raw = localStorage.getItem(featureKey(userId,name)); return raw ? JSON.parse(raw) as T : fallback } catch { return fallback }
}
export function writeLocal(userId: string, name: string, value: unknown) {
  localStorage.setItem(featureKey(userId,name),JSON.stringify(value))
  emitFeatureChange(userId,name)
}
export function clearFeatureData(userId: string, name?: string) {
  const prefix = featureKey(userId,name ?? '')
  for (const key of Object.keys(localStorage)) if (name ? key === prefix : key.startsWith(prefix)) localStorage.removeItem(key)
  emitFeatureChange(userId,name)
}
function emitFeatureChange(userId: string, name?: string) {
  const browser = globalThis as unknown as { window?: { dispatchEvent(event: CustomEvent): void } }
  browser.window?.dispatchEvent(new CustomEvent('shixu:features-changed',{detail:{userId,name}}))
}
export interface OfflineBook { id: string; name: string; poems: Poem[]; downloadedAt: string }
export function offlineBooks(userId: string): OfflineBook[] {
  const value = readLocal<OfflineBook[]>(userId,'offline',[])
  return Array.isArray(value) ? value.filter(b=>typeof b?.id==='string' && Array.isArray(b.poems)) : []
}
export function searchPoems(poems: Poem[], query: string, dynasty = '', tag = '', author = '') {
  const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean)
  return poems.filter(p=>(!dynasty || p.dynasty===dynasty) && (!tag || p.tag===tag) && (!author || p.author===author) && tokens.every(t=>[p.title,p.author,p.dynasty,p.tag,p.content].some(f=>f.toLowerCase().includes(t))))
}
export interface QuizQuestion { poemId: string; prompt: string; answer: string; explanation: string }
export function dailyQuiz(poems: Poem[], date: string): QuizQuestion[] {
  const seed = [...date].reduce((a,c)=>a*31+c.charCodeAt(0),0)>>>0
  if (!poems.length) return []
  const used=new Set<number>()
  return Array.from({length:Math.min(5,poems.length)},(_,i)=> {
    let index=(seed+i*17)%poems.length
    while(used.has(index))index=(index+1)%poems.length
    used.add(index)
    const p=poems[index], verses=poemVerses(p)
    return i%2 && verses.length>1 ? {poemId:p.id,prompt:`请接下一句：${verses[0]}`,answer:verses[1],explanation:`《${p.title}》〔${p.dynasty}〕${p.author}：${verses[0]}，${verses[1]}。`} : {poemId:p.id,prompt:`《${p.title}》的作者是谁？`,answer:p.author,explanation:`《${p.title}》的作者是${p.dynasty}代的${p.author}。`}
  })
}
export function monthDays(month: string) {
  const [year,m]=month.split('-').map(Number)
  return {offset:new Date(Date.UTC(year,m-1,1)).getUTCDay(),days:new Date(Date.UTC(year,m,0)).getUTCDate()}
}
export function moveMonth(month: string, delta: number) {
  const [y,m]=month.split('-').map(Number); const d=new Date(Date.UTC(y,m-1+delta,1))
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth()+1).padStart(2,'0')}`
}
